import script from "./SignInWhatsAppPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInWhatsAppPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInWhatsAppPage.vue?vue&type=style&index=0&id=679db62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-679db62c"]])

export default __exports__